import _request from '@/utils/request';
import { getUrls } from '@/utils/getUrls';
import { _getQuerystr } from '@/utils/commonUtils';

const { TRAINING_URL } = getUrls();

// [来访者] 查询第三方用户参加的class列表
export async function getListByTenant(params) {
  const url = `${TRAINING_URL}api/class/listByTenant${_getQuerystr(params)}`;
  return await _request({
    method: 'GET',
    url,
    ex: true
  })
}